module.exports = __webpack_public_path__ + "static/img/celoscope-detail-24.dbfd182.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-24.jpg
// module id = wDXM
// module chunks = 51